import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { CarPlusIcon } from '../utils/car-plus.icon';
import { AddVehicle } from './add-vehicle';
import { ErrorType } from '@esportal/portal-service';

const CTAStyledAdd = styled(CTA)`
	width: 64px;
	height: 64px;

	& svg {
		width: 32px;
		height: 32px;
	}
`;

const ClickableContainer = styled.div`
	cursor: pointer;
`;

export const EmptyPersonVehicle: React.FC<{
	onAutoClose: () => void;
	onError: (errorType: ErrorType) => void;
}> = ({ onAutoClose, onError }) => {
	const [createVehicleProcess, setCreateVehicleProcess] = React.useState<boolean>(false);
	return (
		<>
			{createVehicleProcess ? (
				<AddVehicle onAutoClose={onAutoClose} onError={onError} />
			) : (
				<Layout
					data-testid="no-car-yet-layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 1 },
							{ name: 'b', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 1 },
							{ name: 'c', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 2 },
							{ name: 'b', columns: 20 },
							{ name: '.', columns: 2 },
							{ name: '.', columns: 1 },
							{ name: 'c', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 2 },
							{ name: 'a', columns: 20 },
							{ name: '.', columns: 2 },
							{ name: '.', columns: 3 },
							{ name: 'b', columns: 18 },
							{ name: '.', columns: 3 },
							{ name: '.', columns: 1 },
							{ name: 'c', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 3 },
							{ name: 'a', columns: 18 },
							{ name: '.', columns: 3 },
							{ name: '.', columns: 4 },
							{ name: 'b', columns: 16 },
							{ name: '.', columns: 4 },
							{ name: '.', columns: 1 },
							{ name: 'c', columns: 22 },
							{ name: '.', columns: 1 },
						],
					}}
					allowOverflowingContent
				>
					<Container wrap={'always'} stretchContent>
						<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
							¡Parece que no conduces ningún Volkswagen!
						</Text>
					</Container>

					<Container wrap={'always'} padding={{ top: ContainerPadding.dynamic0130 }} stretchContent>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							Si tienes uno pero no aparece aquí, añádelo y podrás desbloquear nuevas funcionalidades digitales.
						</Text>
					</Container>

					<Container
						padding={{
							top: ContainerPadding.dynamic0200,
							bottom: ContainerPadding.dynamic0200,
						}}
						gutter={ContainerGutter.dynamic0100}
						horizontalAlign={'center'}
						verticalAlign={'center'}
					>
						<CTAStyledAdd
							tag="button"
							emphasis="primary"
							onClick={() => setCreateVehicleProcess(true)}
							aria-label="Añadir coche"
							icon={<CarPlusIcon />}
						/>
						<ClickableContainer onClick={() => setCreateVehicleProcess(true)}>
							<Text appearance={TokenTextAppearance.bigcopy100}>Añade tu coche</Text>
						</ClickableContainer>
					</Container>
				</Layout>
			)}
		</>
	);
};
